import { render, staticRenderFns } from "./CompanyFieldHeader.vue?vue&type=template&id=24cab532&"
import script from "./CompanyFieldHeader.vue?vue&type=script&lang=ts&"
export * from "./CompanyFieldHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports